module.exports = __webpack_public_path__ + "static/img/stringnosis.fc9d519.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stringnosis.png
// module id = 70Ub
// module chunks = 1